'use client';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';
import PageLoaderSkeleton from '@/components/common/PageLoaderSkeleton';

const Home = () => {
  const router = useRouter();
  useEffect(() => {
    router.push('/dashboard');
  }, [router]);

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'min(420px, 90vw)',
      }}
    >
      <PageLoaderSkeleton />
    </div>
  );
};

export default Home;
